import React from 'react';

import { ArrowLink } from '../../Common/Links';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import * as styles from './GatedForm.module.scss';

const GatedSuccessMessage = ({ isDownloadable, hasOverride, fileUrl, label, successCopy }) => {
  if (isDownloadable && !hasOverride) {
    return (
      <div
        key="arrow-content-available"
        className={[styles.success, 'gated-download-content-available'].join(' ')}
        data-analytics-section={'form-success-message'}
      >
        <div id="recaptcha-container" className="g-recaptcha" data-size="invisible"></div>
        {fileUrl && <ArrowLink url={fileUrl} label={label} isArrowDown isLarge isExternal isDownload />}
      </div>
    );
  } else if (isDownloadable && hasOverride) {
    return (
      <div
        key="rich-text-arrow-content-available"
        className={[styles.success, 'gated-download-content-available'].join(' ')}
        data-analytics-section={'form-success-message'}
      >
        <div id="recaptcha-container" className="g-recaptcha" data-size="invisible"></div>
        <RichTextConverter copy={successCopy} />
        {fileUrl && (
          <div>
            <ArrowLink url={fileUrl} label={label} isArrowDown isLarge isExternal isDownload />
          </div>
        )}
      </div>
    );
  } else if (hasOverride) {
    return (
      <div
        key="rich-text-content-available"
        className={[styles.success, 'gated-content-available'].join(' ')}
        data-analytics-section={'form-success-message'}
      >
        <div id="recaptcha-container" className="g-recaptcha" data-size="invisible"></div>
        <RichTextConverter copy={successCopy} />
      </div>
    );
  }
};

GatedSuccessMessage.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default GatedSuccessMessage;
